import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Style from './index.css';

const Title = (props) => {
    const { title } = props;

    return (
        <div className={Style.title}>
            {title}
        </div>
    );
};

Title.propTypes = {
    title: PropTypes.string
};

export default errorBoundary(Title);
